module.exports = __webpack_public_path__ + "img/level-1.dde05385.png";